export default "__VITE_ASSET__0abee3bc__"